import React, { useEffect, useState } from "react";
import "./Css/Expertise.css"; // Ensure this CSS file exists for styling
import LoadingSpinner from "./LoadingSpinner";
import PageHeader from "./PageHeader";

const expertiseData = [
  {
    title: "Github",
    subtitle: "2500+ Commits, 180+ Repositories",
    icon: "💻",
    link: "https://github.com/shanakasp",
  },
  {
    title: "Medium",
    subtitle: "My blog articles (12+ Articles on programming)",
    icon: "📝",
    link: "https://medium.com/@shanakaprince",
  },
  {
    title: "Stackoverflow",
    subtitle: "640+ Reputation (3.3m Reached)",
    icon: "🔧",
    link: "https://stackoverflow.com/users/17394517",
  },
  {
    title: "Leetcode",
    subtitle: "Solved Leetcode questions (100+ Questions)",
    icon: "💡",
    link: "https://leetcode.com/u/shanakaprince/",
  },
  {
    title: "Fiverr",
    subtitle: "Check my gigs, my services, reviews about myself",
    icon: "💼",
    link: "https://www.fiverr.com/s/wkmNb8q",
  },
  {
    title: "Hacker Rank Profile",
    subtitle: "Solved HackerRank questions ",
    icon: "🏆",
    link: "https://www.hackerrank.com/profile/shanakaprince",
  },

  {
    title: "Beehance",
    subtitle: "Showcasing UI/UX designs & creative projects",
    icon: "🎨",
    link: "https://www.behance.net/shanaka",
  },

  {
    title: "Linkedin Profile",
    subtitle: "Showcasing professional achievements ",
    icon: "🔗",
    link: "https://www.linkedin.com/in/shanaka-prince-810400226/",
  },
];

const Expertise = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 700);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="expertise-container">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          {/* Page Header */}
          <div className="expertise-header">
            <PageHeader title="EXPERTISE" subtitle="Areas of Expertise" />
          </div>

          {/* Expertise Cards */}
          <div className="expertise-card-container">
            {expertiseData.map((item, index) => (
              <a
                key={index}
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="expertise-card-link"
              >
                <div className="expertise-card">
                  <div className="expertise-icon">{item.icon}</div>
                  <h3 className="expertise-title">{item.title}</h3>
                  <p className="expertise-subtitle">{item.subtitle}</p>
                </div>
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Expertise;
